export function GetCategoryTreeArrayWithNameAndId(categoryTree) {
  return categoryTree?.map(({ id, name }) => ({ id, name }));
}
